import React from "react";
import Copy from "@assets/icons/copy.svg";
import useCopyToClipboard from "src/utils/HandleCopyClipboard";

interface CopyButtonProps {
  copyText: string;
  copyMessage: string;
  fillColor?: string;
  copyIconSize?: number;
  buttonSize?: string;
  borderRadius?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  copyText,
  copyMessage,
  copyIconSize = 16,
  buttonSize = "20px",
  borderRadius = "4px",
  fillColor = "bg-bg-page-body",
}) => {
  const { handleCopyClick } = useCopyToClipboard();

  return (
    <div
      className={`flex justify-center items-center cursor-pointer shadow-[0px_2px_4px_0px_rgba(0,0,0,0.08)] ${fillColor} border border-bg-button-secondary`}
      style={{
        width: buttonSize,
        height: buttonSize,
        borderRadius: borderRadius,
      }}
      onClick={() =>
        handleCopyClick({
          copyText: copyText,
          copyMessage: copyMessage,
        })
      }>
      <img src={Copy} width={copyIconSize} height={copyIconSize} alt="copy" />
    </div>
  );
};

export default CopyButton;
